import { atom } from "jotai";

export type PendingCreateExtra = {
  kind?: "page" | "group" | "link";
  externalUrl?: string;
  title?: string;
};

// Side channel for `tree.create(...)` callers: react-arborist drops the `data`
// field when calling onCreate, so we stash the per-call extras here and read
// them back inside the onCreate handler.
//
// IMPORTANT: this is a plain module-level variable, not a jotai atom store
// lookup. Two jotai instances ended up in the dep graph (2.11 + 2.20) which
// each carry their own `getDefaultStore()` — writes via useSetAtom in one
// component and reads via getDefaultStore() in another resolved to *different*
// stores, so the `kind: "group" | "link"` payload was being lost and every
// "new group"/"new link" silently fell back to a plain page.
let pending: PendingCreateExtra | null = null;

export function setPendingCreateExtra(value: PendingCreateExtra | null): void {
  pending = value;
}

export function consumePendingCreateExtra(): PendingCreateExtra | null {
  const value = pending;
  pending = null;
  return value;
}

// Kept for compatibility with any existing imports; reads/writes the same
// module-level state via the helpers above. Direct jotai use is discouraged.
export const pendingCreateExtraAtom = atom<PendingCreateExtra | null>(
  null as PendingCreateExtra | null,
);
